import { render, staticRenderFns } from "./ArtistSongsAccordion.vue?vue&type=template&id=78e1bed4&scoped=true&"
import script from "./ArtistSongsAccordion.vue?vue&type=script&lang=js&"
export * from "./ArtistSongsAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ArtistSongsAccordion.vue?vue&type=style&index=0&id=78e1bed4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e1bed4",
  null
  
)

export default component.exports